import {ParallaxProvider} from "react-scroll-parallax";
import Footer from './Footer';
import {Outlet} from 'react-router';
import Menu from './Menu';


const Layout: React.FC = () => {
    return (
        <ParallaxProvider>
            <Menu/>
            <div className="min-h-screen mt-24 w-screen overflow-hidden bg-gradient-to-r from-gray-600 via-slate-950 to-pink-950">
                <Outlet/>
            </div>
            <Footer/>
        </ParallaxProvider>
    );
}

export default Layout;
